// src/components/WhyPartnerSection.jsx
import React from 'react';
import { Link } from 'react-router-dom';

const REASONS = [
  { icon: 'fa-leaf', title: 'CUSTOM SOLUTIONS', desc: 'Ingredient solutions and specifications aligned with your application requirements.' },
  { icon: 'fa-headset', title: 'EXPERT SUPPORT', desc: 'Commercial and technical support from enquiry through delivery.' },
  { icon: 'fa-box-open', title: 'FLEXIBLE SUPPLY', desc: 'Scalable supply solutions designed around your requirements and timelines.' },
  { icon: 'fa-handshake', title: 'RELIABLE PARTNERSHIP', desc: 'Transparent communication, dependable service and a long-term approach.' },
];

const WhyPartnerSection = () => {
  return (
    <section className="page-content light">
      <div className="container">
        <div className="row" style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
          <div className="col-lg-6 col-md-12">
            <p style={{ color: 'var(--brand-gold)', fontWeight: 700, letterSpacing: 1, marginBottom: 6 }}>WHY PARTNER WITH CORNERSTONE?</p>
            <h2 style={{ color: 'var(--brand-cream)', fontSize: 30, marginBottom: 4 }}>YOUR SUCCESS</h2>
            <h2 style={{ color: 'var(--brand-gold-light)', fontSize: 30, marginBottom: 20 }}>OUR COMMITMENT</h2>

            <div className="row" style={{ display: 'flex', flexWrap: 'wrap' }}>
              {REASONS.map((r, i) => (
                <div className="col-6" key={i} style={{ marginBottom: 22 }}>
                  <i className={`fas ${r.icon}`} style={{ fontSize: 20, color: 'var(--brand-gold)', display: 'block', marginBottom: 8 }}></i>
                  <div style={{ color: 'var(--brand-cream)', fontWeight: 700, fontSize: 13, marginBottom: 4 }}>{r.title}</div>
                  <div style={{ color: 'var(--brand-cream-dim)', fontSize: 12.5 }}>{r.desc}</div>
                </div>
              ))}
            </div>

            <p style={{ margin: '10px 0 20px' }}>
              At Cornerstone, every ingredient represents more than a product — a commitment to purity,
              consistency, performance and partnership.
            </p>
            <Link className="default-button01" to="/contactus">LET'S CREATE WHAT'S NEXT</Link>
          </div>

          <div className="col-lg-6 col-md-12">
            <img
              alt="Essential oil dropper with citrus"
              src="/assets/images/brand/contact_orange.jpg"
              style={{ width: '100%', maxHeight: 480, objectFit: 'cover', objectPosition: 'top', borderRadius: 10, boxShadow: '0 10px 30px rgba(0,0,0,0.4)' }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyPartnerSection;
